// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import Difficulty from "./difficulty_type";

export default {
  userId: __t.u64(),
  get difficulty() {
    return Difficulty;
  },
  boardWidth: __t.u8(),
  boardHeight: __t.u8(),
  minesCount: __t.u16(),
  completionTimeMs: __t.u32(),
  isWin: __t.bool(),
  mineLayout: __t.string(),
  movesData: __t.string(),
};
